import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

const DATE_RANGES = [
  { value: 'all', label: 'All time' },
  { value: '30days', label: '30 days' },
  { value: '90days', label: '90 days' },
  { value: '1year', label: '1 year' },
];

export default function DashboardHeader({ dateRange, onDateRangeChange, onExportCsv, exportDisabled }) {
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground sm:text-[28px]">Emissions overview</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          GHG Protocol Scope 3 · UK DESNZ 2026 conversion factors
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-2 sm:gap-3">
        {/* Segmented time filter — one row above everything it scopes */}
        <div role="radiogroup" aria-label="Time period" className="glass-control inline-flex rounded-full border border-border bg-muted p-0.5">
          {DATE_RANGES.map((option) => {
            const active = dateRange === option.value;
            return (
              <button
                key={option.value}
                type="button"
                role="radio"
                aria-checked={active}
                onPointerDown={() => onDateRangeChange(option.value)}
                onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onDateRangeChange(option.value)}
                className={`rounded-full px-3 py-1.5 text-sm font-medium transition-colors duration-150 sm:px-3.5 ${
                  active ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {option.label}
              </button>
            );
          })}
        </div>

        <Button variant="outline" onClick={onExportCsv} disabled={exportDisabled} className="gap-2 rounded-full">
          <Download className="h-4 w-4" aria-hidden="true" />
          Export CSV
        </Button>
      </div>
    </div>
  );
}
